import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import * as userActions from "../../redux/actions/userActions";
import { bindActionCreators } from "redux";
import ProfilePage from "./ProfilePage";

export function UserProfileContainer({
  viewingUser,
  apiCalls,
  actions,
  ...props
}) {
  useEffect(() => {
    if (viewingUser.username !== props.match.params.username) {
      actions.loadUserFromParams(props.match.params.username);
    }
  }, []);

  function handleSelectUserRecipe(recipe) {
    props.history.push(
      `/cookbook/user/${props.match.params.username}/recipe/${recipe}`
    );
  }
  if (apiCalls === 0 && !viewingUser.username) {
    return (
      <div>
        <h3>User {props.match.params.username} does not exist</h3>
      </div>
    );
  }
  return (
    <ProfilePage
      viewingUser={viewingUser}
      selectUserRecipe={handleSelectUserRecipe}
      apiCalls={apiCalls}
    />
  );
}

UserProfileContainer.propTypes = {
  history: PropTypes.object.isRequired,
  apiCalls: PropTypes.number.isRequired,
  viewingUser: PropTypes.object,
  actions: PropTypes.object,
  match: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    viewingUser: state.viewingUser || {},
    apiCalls: state.apiCallsInProgress,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      loadUserFromParams: bindActionCreators(
        userActions.loadUserFromParams,
        dispatch
      ),
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserProfileContainer);
